import React, {useState, useReducer, useEffect} from 'react';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {Space, Toast} from 'antd-mobile'
import qs from 'qs';
import { Base64 } from 'js-base64';
import routerConfig from './router/index';
import RouterUI from '@/router/RouterUI';
import api from "@/services/api/index";
import PageLoading from '@/components/BaseComponent/PageLoading';
import AppContext from './common/AppContext';
import commonHelper from '@/utils/commonHelper';
import {searchPath} from '@/util/stringUtil.ts';
import commonSetting from '@/config/commonSetting'
import commonEnum from '@/config/commonEnum'
import {initWxConfig} from '@/config/wx-helper'
import { getUserAgent } from '@/util/handleUrlParams'

function reducer(prevState, action) {
    // reducer will read the value from the latest render
    const {count: prevCount} = prevState;
    const {type, payload} = action;
    if (type === "tokens") {
        return {...prevState, tokens: payload};
    } else if (type === "wxInfo") {
        return {...prevState, wxInfo: payload};
    } else if (type === "userInfo") {
        return {...prevState, userInfo: payload};
    } else if (type === "redirect") {
        return {...prevState, redirect: payload};
    } else if (type === "tokenInfo") {
        return {...prevState, tokenInfo: payload};		
    } else if (type === "videoList") {	
        return {...prevState, videoList: payload};		
    } else {
        throw new Error();
    }
}

const App = (props) => {

    const [loading, setLoading] = useState(false)
    const [state, dispatch] = useReducer(reducer, {
        accountType: commonSetting.ACCOUNT_TYPE,
        productType: commonSetting.PRODUCT_TYPE,
        videoList: []
    });
    let history = useHistory();
    const isWechatEnv = getUserAgent().get("isWechat")
    console.log('history', history)

    const getInitialState = async () => {
        console.log(isWechatEnv, '>>>>>>>>>>>>>>>>>')
        
        // TODO
        // localStorage.setItem('accessToken','')
        let accessToken = localStorage.getItem('accessToken');
        let query = qs.parse(history.location.search, {ignoreQueryPrefix: true})
        if (query.mockToken) {
            accessToken = query.mockToken;
            localStorage.setItem('accessToken', accessToken);
        }
        let params;
        if (history.location.pathname && !searchPath(commonSetting.WHITE_PAGE_LIST, history.location.pathname)) {
            const isRedirectPath = history.location.pathname == '/redirect'
            const isO2nPath = history.location.pathname == '/o2n'
            if (isO2nPath) {

                let {path, wxId} = query;

                if (accessToken) {
                    //TODO accountType
                    let {wxId: _wxId} = JSON.parse(Base64.decode(accessToken.split('.')[1]))
                    if (wxId != _wxId) {
                        await commonHelper.redirectWxAuthorizationUrl(path, state.productType)
                        return
                    }
                } else {

                    await commonHelper.redirectWxAuthorizationUrl(path, state.productType)
                    return
                }

            }
            if (isRedirectPath) {
                params = JSON.parse(query?.params)
                if (params) {
                    accessToken = params.accessToken
                    localStorage.setItem('accessToken', params.accessToken);
                    localStorage.setItem('refreshToken', params.refreshToken);
                    localStorage.setItem('salesNumber', params.salesNumber);
                    localStorage.setItem('salesId', params.salesId);
                    localStorage.setItem('accountType', params.accountType);
                    localStorage.setItem('openId', query.open_id);
                    localStorage.setItem('wxId', query.wxId);
                    localStorage.setItem('userId', query.userId);
                }
            }
            if (accessToken && accessToken.split('.')[1]) {
                let token = localStorage.getItem('accessToken')
                let tokenQuery = JSON.parse(decodeURIComponent(escape(window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/")))));
                let wxId = tokenQuery.wxId
                let userId = tokenQuery.userId
                if (wxId || userId) {
                    let resp = await api.userController.usersProfileUsingGET({
                        noCache: true
                    });
                    // debugger
                    if (resp?.code == 0) {
                        if (isWechatEnv) {
                            //TODO
                            await initWxConfig()
                        }
                        console.log(resp.data, '--------------------------cbjdb')
                        // 判断注册完成，更新token
                        if (!userId && resp.data?.wxInfo?.userId) {
                            await commonHelper.redirectWxAuthorizationUrl(history.location.pathname + history.location.search, state.productType)
                            return
                        }
                        if (!resp.data?.wxInfo && isWechatEnv) {
                            await commonHelper.redirectWxAuthorizationUrl(history.location.pathname + history.location.search, state.productType)
                            return
                        }
                        dispatch({		
                            type: 'tokenInfo',		
                            payload: tokenQuery		
                        })
                        dispatch({
                            type: 'wxInfo',
                            payload: resp.data.wxInfo
                        })
                        dispatch({
                            type: 'userInfo',
                            payload: resp.data.userInfo
                        })
                        return resp.data;
                    } else {
                        await commonHelper.redirectWxAuthorizationUrl(history.location.pathname + history.location.search, state.productType)
                        return
                    }
                } else {
                    history.replace({
                        pathname: '/authorization',
                        search: `path=${encodeURIComponent(query.path)}`,
                      })
                    return
                }
                
            } else if (!isRedirectPath) {
                await commonHelper.redirectWxAuthorizationUrl(history.location.pathname + history.location.search, state.productType)
                return
            }
        }
        return;
    }

    const goRegister = (redirect) => {
        let params = {
            accessToken: localStorage.getItem('accessToken'),
            salesId: localStorage.getItem('salesId'),
            salesNumber: localStorage.getItem('salesNumber'),
            refreshToken: localStorage.getItem('refreshToken') || "",
            source: 'prod',
            productType: commonSetting.PRODUCT_TYPE
        }
        let query = `params=${encodeURIComponent(JSON.stringify(params))}`
        window.location.href = commonSetting.GC_ACCESS_URL + `redirect?path=/register?redirect=${encodeURIComponent(redirect)}&${query}&open_id=${localStorage.getItem('openId') || ""}&wxId=${localStorage.getItem('wxId') || ""}`
        // }
    }

    useEffect(() => {
        setLoading(true)
        getInitialState().then(data => {
            console.log(data);
            if(data || searchPath(commonSetting.WHITE_PAGE_LIST, history.location.pathname) || history.location.pathname == '/redirect'){
                setLoading(false)
            }
        }).catch(error => console.log(error))
    }, [])
    return (
        <>
            <AppContext.Provider value={{...state, dispatch: dispatch}}>
                {
                    loading ? <PageLoading></PageLoading>
                        : <RouterUI routers={routerConfig.routes}/>
                }
            </AppContext.Provider>
        </>
    );
}

export default App;
